import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitBooking = (data) => axios.post(`${API}/booking`, data);
export const submitContact = (data) => axios.post(`${API}/contact`, data);
export const createServiceOrder = (payload) => axios.post(`${API}/payments/order`, payload);
export const verifyServicePayment = (payload) => axios.post(`${API}/payments/verify`, payload);
export const redeemPromo = (payload) => axios.post(`${API}/promo/redeem`, payload);
export const quotePromo = (payload) => axios.post(`${API}/promo/quote`, payload);
export const holdSlot = (payload) => axios.post(`${API}/slot-hold`, payload);
export const fetchPublicConfig = () => axios.get(`${API}/config`);
